'use client';

type FormFieldLabelProps = {
    title: string;
    className?: string;
};

export default function FormFieldLabel({ title, className = '' }: FormFieldLabelProps) {
    return (
        <div
            className={`flex justify-center w-auto min-w-[80px] text-center font-corp font-medium text-xs text-white bg-color-base rounded-lg tracking-wide whitespace-nowrap px-2 py-1 ${className} select-none`}
        >
            {title}
        </div>
    );
}
